import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: '0 8px 0 8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      fill: theme.palette.text.disabled
    },
    '&:hover': {
      cursor: 'pointer',
      '& *': {
        fill: theme.palette.secondary.main,
        color: theme.palette.secondary.main
      }
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 0 8px',
      display: ({ hideOnMobile }) => `${hideOnMobile ? 'none' : 'flex'}`,
      justifyContent: 'flex-end',
      '& .MuiSvgIcon-root': {
        fill: theme.palette.secondary.main,
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
}));

const NavLinkWrapper = ({
  children,
  hideOnMobile,
  handleClick,
  dataTestId
}) => {
  const classes = useStyles({ hideOnMobile });
  return (
    <Box
      data-testid={dataTestId}
      onClick={handleClick}
      className={classes.wrapper}
    >
      {children}
    </Box>
  );
};

NavLinkWrapper.propTypes = {
  classes: PropTypes.shape({}),
  children: PropTypes.array,
  hideOnMobile: PropTypes.bool,
  dataTestId: PropTypes.string,
  handleClick: PropTypes.func
};

export default NavLinkWrapper;
